class Efds {
    static get $inject() {
        return ['gql']
    }

    static get importEfdQuery() {
        return gql`
            mutation ImportEfd($empresaId: String!, $tipo: EfdTipo!, $arquivo: String!) {
                empresa(id: $empresaId) {
                    efd: importEfd(tipo: $tipo, arquivo: $arquivo) {
                        tipo
                        versao
                        finalidade
                        dataInicio
                        dataFim
                        dataReferencia
                    }
                }
            }
        `
    }

    constructor(gql) {
        this.gql = gql
    }

    listEfdsBy(empresaId, filter) {
        const query = gql`
            query Efds($empresaId: Int!, $filter: EfdFilter!) {
                empresa(id: $empresaId) {
                    id
                    efds(filter: $filter) {
                        id
                        tipo
                        versao
                        finalidade
                        dataInicio
                        dataFim
                        dataReferencia
                        dataEnvio
                        alertasTotalCount
                        filial {
                            id
                            produtosContrataveis
                        }
                    }
                }
            }
        `

        const variables = {
            empresaId: parseInt(empresaId),
            filter
        }

        return this.gql
            .query(query, variables)
            .then(({ empresa: { efds } }) => efds)
    }

    importEfdIcms(empresaId, icms, options = {}) {
        const variables = {
            empresaId: empresaId.toString(),
            tipo: 'ICMS',
            arquivo: icms
        }

        return this.gql
            .mutate(Efds.importEfdQuery, variables, options)
            .then(({ empresa: { efd } }) => efd)
    }

    importEfdPisCofins(empresaId, pisCofins, options = {}) {
        const variables = {
            empresaId: empresaId.toString(),
            tipo: 'PIS_COFINS',
            arquivo: pisCofins
        }

        return this.gql
            .mutate(Efds.importEfdQuery, variables, options)
            .then(({ empresa: { efd } }) => efd)
    }

    extractHeader(file) {
        return new Response(file.slice(0, 2000))
            .text()
            .then(text => text.split("\n")[0])
            .then(header => {
                const splitted = header.split("|")
                return splitted.slice(1, splitted.length - 1)
            })
            .then(header => {
                if (header.length === 15) return this._extractHeaderIcms(header)
                if (header.length === 14) return this._extractHeaderPisCofins(header)

                return Promise.reject('invalid_file')
            })
    }

    _extractHeaderIcms(header) {
        return {
            tipo: 'ICMS',
            dataReferencia: this._referenceDate(header[3]),
            registro: header[0],
            versao: header[1],
            finalidade: header[2],
            dataInicio: this._parseDate(header[3]),
            dataFim: this._parseDate(header[4]),
            razaoSocial: header[5],
            cnpj: header[6]
        }
    }

    _extractHeaderPisCofins(header) {
        return {
            tipo: 'PIS_COFINS',
            dataReferencia: this._referenceDate(header[5]),
            registro: header[0],
            versao: header[1],
            finalidade: header[2],
            dataInicio: this._parseDate(header[5]),
            dataFim: this._parseDate(header[6]),
            razaoSocial: header[7],
            cnpj: header[8]
        }
    }

    _referenceDate(dateStr) {
        const date = this._parseDate(dateStr)

        date.setDate(1)

        return date
    }

    _parseDate(dateStr) {
        const day = parseInt(dateStr.substr(0, 2))
        const month = parseInt(dateStr.substr(2, 2)) - 1
        const year = parseInt(dateStr.substr(4, 4))

        return new Date(year, month, day)
    }
}

angular.module('eficienciaFiscalModule').service('Efds', Efds)
